import { Link } from "react-router-dom";

const Header = () => {
    return (
        <div>
            <nav className="navbar navbar-expand-lg bg-transparent ">
                <div className="container-fluid ">
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarNav">
                        <ul className="navbar-nav mx-auto letter-header">
                            <li className="nav-item">
                                <Link className="nav-link text-uppercase" to="">Home</Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link text-uppercase" to="/Premios">Premios</Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link text-uppercase" to="/Galeria">Galería</Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link text-uppercase" to="/Anteriores">Años Anteriores</Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link text-uppercase" to="/Bases">Bases y Mecánicas</Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </div>
    )
}
export default Header;